import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46d90a4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-rb" }

import { nextTick, onBeforeUnmount, onMounted } from 'vue'
import BackToTop from '@/components/BackToTop.vue'
import FloatingIsland from '@/components/FloatingIsland.vue'

// 要判斷的 footer 元素

export default /*#__PURE__*/_defineComponent({
  __name: 'FixedRb',
  setup(__props) {

const footerSelectors = [
  '.cart-toolbar-footer'
]

// 調整右下固定區塊的位置
const positionControl = () => {
  const fixedEl = document.querySelector('.fixed-rb') as HTMLElement | null
  const footerToolbars: HTMLElement[] = footerSelectors
    .map(sel => document.querySelector(sel) as HTMLElement | null)
    .filter((el): el is HTMLElement => el !== null)

  if (fixedEl && footerToolbars.length) {
    // 找出最高的 footer
    const highestFooter = footerToolbars.reduce((prev, curr) =>
      curr.clientHeight > prev.clientHeight ? curr : prev
    )

    // 更新位置
    fixedEl.style.bottom = highestFooter.clientHeight + 10 + 'px'
  } else if (fixedEl) {
    // 沒找到 footer 時恢復預設 CSS
    fixedEl.style.removeProperty('bottom')
  }
}

// ----- lifecycle -----
onMounted(async () => {
  await nextTick()
  requestAnimationFrame(() => {
    positionControl() // 初次執行
  })

  document.getElementById('app')?.addEventListener('scroll', positionControl)
  window.addEventListener('resize', positionControl)
})

onBeforeUnmount(() => {
  document.getElementById('app')?.removeEventListener('scroll', positionControl)
  window.removeEventListener('resize', positionControl)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BackToTop),
    _createVNode(FloatingIsland)
  ]))
}
}

})